<p-dialog
	header="Save history"
	[(visible)]="visible"
	[modal]="true"
	[dismissableMask]="true"
	[style]="{ width: '860px', maxHeight: '82vh' }"
	appendTo="body"
>
	<div class="save-history-body">
		@if (error()) {
			<div class="text-[12px] text-wb-danger">{{ error() }}</div>
		}

		<div class="save-history">
			<!-- Left: event list -->
			<div class="save-history__list">
				@if (loading()) {
					<div class="save-history__empty">Loading…</div>
				} @else if (events().length === 0) {
					<div class="save-history__empty">No saves yet.</div>
				} @else {
					@for (ev of events(); track ev._id) {
						<button
							class="save-event"
							[class.save-event--selected]="selectedId() === ev._id"
							(click)="selectEvent(ev)"
						>
							<span class="save-event__status">
								@if (ev.applied) {
									<i class="pi pi-check-circle text-wb-success"></i>
								} @else {
									<i class="pi pi-exclamation-triangle text-wb-danger" [title]="ev.applyError ?? 'Not saved'"></i>
								}
							</span>
							<span class="save-event__body">
								<span class="save-event__file" [title]="ev.path">{{ fileLabel(ev.path) }}</span>
								<span class="save-event__meta">
									<span class="save-event__trigger">{{ ev.trigger ?? '—' }}</span>
									<span class="save-event__time">{{ ev.createdAt | date:'short' }}</span>
								</span>
							</span>
						</button>
					}
				}
			</div>

			<!-- Right: diff -->
			<div class="save-history__diff">
				@if (!selectedId()) {
					<div class="save-history__empty">Select a save on the left to see its changes.</div>
				} @else if (diffLoading()) {
					<div class="save-history__empty">Loading diff…</div>
				} @else if (diff(); as entries) {
					@if (!hasPrevious()) {
						<div class="save-history__note">First save of this file — everything is new.</div>
					}
					@if (entries.length === 0) {
						<div class="save-history__empty">No changes from the previous save.</div>
					} @else {
						<div class="diff-count">{{ entries.length }} changed fields</div>
						<div class="diff-list">
							@for (d of entries; track d.path) {
								<div class="diff-row">
									<div class="diff-path" [title]="d.path">{{ d.path }}</div>
									<div class="diff-values">
										<span class="diff-before" [title]="fmt(d.before)">− {{ fmt(d.before) }}</span>
										<span class="diff-after" [title]="fmt(d.after)">+ {{ fmt(d.after) }}</span>
									</div>
								</div>
							}
						</div>
					}
				}
			</div>
		</div>
	</div>
</p-dialog>
